<template>
  <div class="page-editor__container page-editor__container--small">
    <!-- <base-heading>{{ $t('outreach.intro.title') }}</base-heading> deleted on SR-1443-->
    <base-card
      v-if="loading"
      condensed
      style="opacity: 0.5"
    >
      <base-skeleton no-background>
        <div class="skeleton__item mt-2" />
        <hr class="divider">
        <div class="skeleton__item" />
        <hr class="divider">
        <div
          class="skeleton__item"
          style="height: 200px"
        />
      </base-skeleton>
    </base-card>
    <base-card
      v-else
      condensed
    >
      <div class="m-2">
        <div class="d-flex align-items-center">
          <base-text class="mr-3 customtext">
            {{ $t('outreach.intro.to') }}
          </base-text>
          <email-recipients-editor
            :key="recipientsKey"
            class="w-100"
            :item="item"
            :recipients="recipients"
            @save="$emit('save', ['to_groups', 'to_customers', 'url'])"
          />
        </div>
        <hr class="divider">
        <div class="d-flex align-items-center">
          <base-text class="mr-3 customtext" style="padding: 7px 0px 19px 0px !important;">
            {{ $t('outreach.intro.subject') }}
          </base-text>
          <editor-subject
            ref="editorSubject"
            v-model="item.subject"
          />
        </div>
        <hr class="divider">
      </div>
      <editor-intro-text
        v-model="item.intro"
        :attachment-name="attachmentName"
        @upload-attachment="uploadAttachment"
        @clear-attachment="clearAttachment"
        @attachment-error="attachmentError"
      />
    </base-card>
  </div>
</template>
<script>
import EditorIntroText from '@/pages/entries/EditorIntroText';
import EmailRecipientsEditor from '@/components/Widgets/DraftEditor/EmailRecipientsEditor';
import EditorSubject from '@/pages/entries/EditorSubject';
import { EventBus } from '@/event-bus';

export default {
  name: 'IntroTextEditor',

  components: {
    EditorIntroText,
    EmailRecipientsEditor,
    EditorSubject,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    recipients: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      recipientsKey: Date.now(),
    };
  },

  computed: {
    item: {
      get() {
        return this.$store.state.entries.item;
      },
      set(value) {
        return this.$store.commit('entries/updateData', value);
      },
    },
    attachmentName() {
      if (!this.item.attachment) return null;
      return this.item.attachment.name;
    },
  },
  watch: {
    'item.subject': {
      handler() {
        this.$emit('save', ['subject', 'url']);
      },
    },
    'item.intro': {
      handler() {
        this.$emit('save', ['intro', 'url']);
      },
    },
  },
  mounted() {
    EventBus.$on('restart-recipients-customers', () => {
      this.recipientsKey = Date.now();
    });
  },
  methods: {
    uploadAttachment(url) {
      this.item.attachment = url;
      this.$emit('save');
    },
    clearAttachment() {
      this.item.attachment = null;
      this.$emit('save');
    },
    attachmentError(error) {
      EventBus.$emit('toast-error', error);
    },
  },
};
</script>
<style lang="css" scoped>
.page-editor__container {
  margin-bottom: 1.5rem;
  max-width: 812px;
}

.divider {
  border-top: transparent;
  border-bottom: 1px solid #ccc;
}

.customtext {
  font-size: 14px;
  white-space: nowrap;
  color: #1b1b1b;
  font-weight: 500;
  line-height: 135%;
  font-family: 'SilkaMedium';
}

  ::v-deep .ql-editor{
    padding: 8px 90px 8px 14px !important;
  }
</style>
